<template>
  <div class="modal-cover" @click="onClose" v-if="!isLeaved">
    <div class="white-noise-container" @click.stop>
      <div class="white-noise-header-container">
        <button class="close-modal" @click="onClose"></button>
        <div>{{ $t('camstudy.whiteNoise.title') }}</div>
        <div class="white-noise-icon"></div>
      </div>
      <div v-if="whiteNoisePlayList.length" class="white-noise-off" @click="pauseWhiteNoise">{{ $t('camstudy.whiteNoise.turnOff') }}</div>
      <ul v-if="whiteNoisePlayList.length" class="white-noise-body-container">
        <li v-for="whiteNoise in whiteNoisePlayList"
            :key="whiteNoise.whiteNoiseId"
            :class="{'white-noise-item': true, active: whiteNoise.whiteNoiseId === currentWhiteNoise.whiteNoiseId}"
            @click="changeWhiteNoisePlayList(whiteNoise)">
          {{ $t("camstudy.item.whiteNoise." + whiteNoise.title) }}
        </li>
      </ul>
      <div v-else class="white-noise-body-container">
        <div class="h-full w-full p-3 flex flex-col items-center justify-center text-white noise-none">
          <div class="none-message">
            {{$t('camstudy.stopwatch.noItem')}}
          </div>
          <button @click="onClickStickerPage">구매하기</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
  name: "CamstudyWhiteNoiseModal",
  data() {
    return {

    }
  },
  mounted() {
    this.getWhiteNoisePlayList();
  },
  computed: {
    ...mapGetters('camstudy', [
        'whiteNoisePlayList',
        'currentWhiteNoise'
    ]),
    ...mapGetters('room', [
      'isLeaved',
    ]),
  },
  methods: {
    ...mapActions('camstudy', [
        'getWhiteNoisePlayList',
        'changeWhiteNoisePlayList',
    ]),
    pauseWhiteNoise() {
      if(Object.keys(this.currentWhiteNoise || {}).length <= 0) {
        return;
      }

      this.changeWhiteNoisePlayList(this.currentWhiteNoise);
    },
    onClose() {
      this.$modal('CamstudyWhiteNoiseModal', {once: true})
    },
    onClickStickerPage(){
      this.$camsAlert({
        title: this.$t('camstudy.stopwatch.noItem'),
        text: this.$t('camstudy.stopwatch.shopText'),
        okText: this.$t('camstudy.stopwatch.move'),
        ok: () => {
          const env = process.env.NODE_ENV;
          if(env === 'development') {
            window.open('https://cams-dev.gooroomee.com/camstudy/shop', '_blank');
          }else if(env === 'production') {
            window.open('https://gooroomee.com/camstudy/shop', '_blank');
          }
        }
      })
    }
  }
}

</script>

<style scoped lang="scss">
[grm-device-mobile] {
  .modal-cover {
    background-color: rgba(0, 0, 0, 0.5);
    @media(orientation: portrait) {
      left: 0;
      right: 0;
      bottom: 64px;
    }
    @media(orientation: landscape) {
      left: env(safe-area-inset-left);
      right: env(safe-area-inset-right);
      bottom: 98px;
      z-index: 99;
    }
    .white-noise-container {
      @media(orientation: portrait) {
        bottom: 0;
        left: 0;
        width: 100%;
        .white-noise-body-container {
          height: 331px;
        }
      }
      @media(orientation: landscape) {
        bottom: 0;
        left: 0;
        right: 0;
        top: 0;
        .white-noise-body-container {
          height: calc(100% - 44px);
        }
      }
    }
  }
}
html:not([grm-device-mobile]) {
  .modal-cover {
    left: 0;
    right: 0;
    bottom: 80px;
    top: 0;
    .white-noise-container{
      bottom: -80px;
      top: 0;
      right: 0;
      width: 360px;
      border-left: 0.5px solid rgba(255, 255, 255, 0.20);
      background: #1A1A1A;
      .white-noise-body-container {
        height: calc(100% - 44px);
      }
    }
  }
}
.modal-cover{
  position: fixed;
  top: 0;
  z-index: 2;
}
.white-noise-container {
  position: absolute;
  line-height: 1.5;
  background: #1F1F1F;
  color: white;
  z-index: 100;

  .white-noise-header-container {
    display: flex;
    padding: 6px 16px;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
  }

  .white-noise-body-container {
    padding: 0 0 12px;
    overflow-y: scroll;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  .white-noise-item{
    padding: 12px 20px 12px 56px;
    font-size: 14px;
    background: url("~@/assets/images/camstudy/ico_music_white.svg") center left 20px no-repeat;

    &.active{
      background-color: #393939;
    }
  }

  .white-noise-off {
    padding: 12px 20px 12px 56px;
    font-size: 14px;
    background: url("~@/assets/images/camstudy/ico_music_off_white.svg") center left 20px no-repeat;
  }

  .close-modal {
    width: 32px;
    height: 32px;
    background: url("~@/assets/images/camstudy/ico_close_white.svg") center no-repeat;
    background-size: auto 24px;
  }

  .white-noise-icon {
    width: 32px;
    height: 32px;
    //background: url("~@/assets/images/camstudy/ico_white_noise.svg") center no-repeat;
  }
}
.noise-none{
  button{
    padding: 10px 24px;
    background-color: #016FF2;
    border-radius: 4px;
    font-size: 13px;
    font-weight: 500;
  }
}
.none-message{
  margin-bottom: 14px;
  font-size: 14px;
  font-weight: bold;
}
</style>